module.exports = __webpack_public_path__ + "img/me.415fb1e9.svg";